import { render, staticRenderFns } from "./_resetPassword.vue?vue&type=template&id=6cc09e48&lang=pug"
import script from "./_resetPassword.vue?vue&type=script&lang=js"
export * from "./_resetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports